<script setup lang="ts">
import { watch, ref } from 'vue'
import { useRoute } from 'vue-router'
import { TopProgress } from '@/shared/ui/TopProgress'
import { useAccount } from '@/apps/adok/entities/account'
import { AcceptTermsModal } from '@/apps/adok/features/account/accept-terms'

import { TrackingPixel } from './telemetry'
import { SupportWidget } from './support-widget'

const { isStaff, accountId } = useAccount()

const route = useRoute()
const showPixel = ref(accountId.value > 0)

watch(accountId, (id) => {
  if (id) showPixel.value = true
})

watch(
  () => route.meta.auth,
  (auth) => {
    if (auth) showPixel.value = true
  }
)
</script>

<template>
  <div id="app">
    <TopProgress />
    <router-view />
    <TrackingPixel v-if="showPixel && !isStaff" />
    <SupportWidget />
    <AcceptTermsModal v-if="accountId > 0 && !isStaff && !route.meta.auth" />
  </div>
</template>
